module.exports = __webpack_public_path__ + "static/media/solutions-spbinder.27dd4246.svg";